import React, { Component } from 'react';
import { serverIp, firebaseAuth, logComponentLoad, } from '../../../../config/constants.js'
import { Table, Header } from 'semantic-ui-react'
import * as UiConsts from '../../../../config/UiConstants'
import axios from 'axios'
import { getPrintValues, checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';

class ViewProject_header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            largeProject: '',
        }
    }

    componentDidMount() {

        this.getProject();
    }


    getProject = () => {


        axios.post(serverIp + 'large_project_items/getLargeProject', {
            apiKey: "ViewProject_header",
            projectId: this.props.projectId,
            enteredBy: this.props.user.email
        })
            .then((response) => {
                console.log(response.data);

                console.log("entx22 result:" + response.data.result);

                if (response.data.result) {

                    if (response.data.largeProject) {

                        this.setState({
                            loading: false,
                            largeProject: response.data.largeProject,
                        })
                    }

                } else {

                    this.setState({ loading: false });

                    alert("error:" + response.data.message);

                }
                //this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                //this.setState({ loading: false })
            });
    }

    render() {

        const headerUi = this.state.largeProject != '' ?
            <Header dividing
                as='h2'
                content={this.state.largeProject.name}
                textAlign='center'
                subheader={this.state.largeProject.largeProjectCustomer.customerName}
            />
            : ''


        return (this.state.loading === true ? <UiConsts.LoadingComponent /> :
            <div>

                {headerUi}

            </div>
        )
    }
}

export default ViewProject_header;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjectOrderEntry/ViewProject_header.js